import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appUppercase]',
  standalone: true
})

export class UppercaseDirective {
  constructor(private el: ElementRef) { }
  @HostListener('input', ['$event']) onInput() {
    const input = this.el.nativeElement as HTMLInputElement;
    input.value = input.value.toUpperCase();
    input.dispatchEvent(new Event('input'));
  }
}
